import { render, staticRenderFns } from "./HelpCenterFAQ.vue?vue&type=template&id=c17cef88&scoped=true&"
import script from "./HelpCenterFAQ.vue?vue&type=script&lang=ts&"
export * from "./HelpCenterFAQ.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17cef88",
  null
  
)

export default component.exports